import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ROUTES, ROUTE_PARAMS } from '@futrli/shared-services';

import { DocumentLibraryContainer } from './document-library-container';
import { OnboardingContainer } from './onboarding-container';
import { ReportContainer } from './report-container';
import { ReportsContainer } from '../../reports/reports-container';
import { TemplateContainer } from './template-container';

export const ReportingContainer = () => {
  return (
    <Routes>
      <Route path={ROUTES.ONBOARDING_ROUTE} element={<OnboardingContainer />} />
      <Route path={`/:${ROUTE_PARAMS.REPORT_ID}/edit/onboarding/:stepId`} element={<ReportContainer />} />
      <Route path={`/:${ROUTE_PARAMS.REPORT_ID}/*`} element={<ReportContainer />} />

      <Route path={`/template/:${ROUTE_PARAMS.TEMPLATE_ID}/*`} element={<TemplateContainer />} />

      <Route path={`${ROUTES.DOCUMENT_LIBRARY}/*`} element={<DocumentLibraryContainer />} />

      <Route path={ROUTES.REPORTS_LIST} element={<ReportsContainer />} />
      <Route path={ROUTES.REPORT_SCHEDULING} element={<ReportsContainer />} />
      <Route path={ROUTES.EXPORTED_PDFS} element={<ReportsContainer />} />
      <Route path={ROUTES.REPORT_TEMPLATES} element={<ReportsContainer />} />
      <Route path={ROUTES.FUTRLI_TEMPLATES} element={<ReportsContainer />} />
      <Route path="/" element={<ReportsContainer />} />
      <Route path="*" element={<ReportsContainer />} />
    </Routes>
  );
};
